var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeeper3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1440px",
    height: "420px",
    viewBox: "0 0 1440 420",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy",
    transform: "translate(0.000000, -2307.000000)",
    fill: "#355763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "innovative..",
    transform: "translate(0.000000, 772.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1554.72607 C30.3841183,1604.40352 108.015873,1627.41312 232.895264,1623.75488 C420.21435,1618.26752 466.808869,1539.48587 639.092041,1536.00439 C811.375213,1532.52292 872.325773,1596.62327 987.792969,1608.5 C1103.26016,1620.37673 1185.17219,1597.35408 1282.15002,1602.14807 C1346.80191,1605.34406 1399.3464,1614.90925 1439.78349,1630.84363 L1439.78349,1954.48865 L0,1954.48865",
    id: "Path-3"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeeper3);
export default __webpack_public_path__ + "static/media/deeper3.b837764b92b5f6dcbe0eacfaa291c28d.svg";
export { ForwardRef as ReactComponent };